import { lazy } from 'react';

const CourseListModal = lazy(() => import('./components/CourseListingModal'));
const SchoolFilterModal = lazy(() => import('./components/SchoolFilterModal'));
const AboutSchooLinksModal = lazy(
  () => import('./components/AboutSchooLinksModal'),
);

export default {
  COURSE_LIST_MODAL: CourseListModal,
  PPC_SCHOOL_FILTER_MODAL: SchoolFilterModal,
  ABOUT_SCHOOLINKS_MODAL: AboutSchooLinksModal,
};
